const renderReasonMessage = props => {
  const options = [
    {
      label: 'Select Your Option',
    },
  ]
  props &&
    props.reasonCode &&
    props.reasonCode.map(code => {
      options.push({
        label: code,
        value: code,
      })
    })
  return options
}

export const returnFormInput = props => {
  const returnReasonMessage = renderReasonMessage(props)
  const returnFormArray = [
    [
      {
        name: 'returnReason',
        type: 'select',
        dataTestId: 'qa-dropdown',
        ariaLabel: 'selectReason',
        options: returnReasonMessage,
        columnType: {
          lg: '6',
          md: '9',
          sm: '9',
          xs: '8',
        },
      },
      {
        name: 'quantity',
        columnType: {
          lg: '3',
          md: '3',
          sm: '3',
        },
        RenderProps: props.quantityProp,
      },
      {
        name: 'others',
        type: 'textarea',
        ariaLabel: 'otherReason',
        columnType: {
          lg: '9',
          md: '12',
        },
      },
    ],
  ]
  return returnFormArray
}
